import { createTypedSxStyles, capitalDesignTokens } from '@opengov/capital-mui-theme';

const muiV37Gray50 = '#F8F8F8';
const muiV37BlackOpacity12 = 'rgba(0, 0, 0, 0.12)';

export const styles = createTypedSxStyles({
  tableContainer: {
    border: `1px solid ${muiV37BlackOpacity12}`,
    borderRadius: '4px'
  },
  tableRow: {
    backgroundColor: muiV37Gray50
  },
  arrowCell: {
    minWidth: '67px'
  },
  reportNameCell: {
    width: '30%'
  },
  reportNameText: {
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold
  },
  storiesCountCell: {
    width: '50%'
  },
  spinnerContainer: {
    display: 'flex'
  },
  actionsCell: {
    minWidth: '240px'
  },
  editButton: {
    marginRight: '16px',
    backgroundColor: muiV37Gray50,
    color: capitalDesignTokens.foundations.colors.gray900,
    border: `1px solid ${muiV37BlackOpacity12}`,
    '&:hover': {
      backgroundColor: muiV37Gray50,
      color: capitalDesignTokens.foundations.colors.gray900
    },
    '&&.Mui-disabled': {
      opacity: 0.5,
      color: capitalDesignTokens.foundations.colors.gray900
    }
  },
  updateButton: {
    backgroundColor: muiV37Gray50,
    color: capitalDesignTokens.foundations.colors.gray900,
    border: `1px solid ${muiV37BlackOpacity12}`,
    '&:hover': {
      backgroundColor: muiV37Gray50,
      color: capitalDesignTokens.foundations.colors.gray900
    },
    '&&.Mui-disabled': {
      opacity: 0.5,
      color: capitalDesignTokens.foundations.colors.gray900
    }
  },
  textField: {
    width: '100%',
    '&& .no-format:focus': {
      border: `0px solid ${capitalDesignTokens.semanticColors.interaction.focus}`,
      padding: '4px 10px'
    },
    '&& .no-format:hover': {
      border: 'none'
    }
  },
  filtersContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px'
  },
  searchTextField: {
    maxWidth: '300px'
  },
  sortTextField: {
    maxWidth: '220px'
  },
  noResultsText: {
    padding: '16px',
    textAlign: 'center'
  }
});
